import {
  ISearchSlim360O365AiTimeSavings,
  ISlim360O365AiTimeSavings,
} from '../../../services/slim360/o365AiTimeSavings/o365AiTimeSavings.model';
import o365AiTimeSavingsService from '../../../services/slim360/o365AiTimeSavings/o365AiTimeSavings.service';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Asynchronous thunk action

export const searchSlim360O365AiTimeSavings = createAsyncThunk(
  'searchSlim360O365AiTimeSavings',
  async (searchParam?: ISearchSlim360O365AiTimeSavings) => {
    const response = await o365AiTimeSavingsService
      .searchSlim360O365AiTimeSavings(searchParam)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);

export const getSlim360O365AiTimeSavingsById = createAsyncThunk(
  'getSlim360O365AiTimeSavingsById',
  async (id: number) => {
    const response = await o365AiTimeSavingsService
      .getSlim360O365AiTimeSavingsById(id)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);

export const saveSlim360O365AiTimeSavings = createAsyncThunk(
  'saveSlim360O365AiTimeSavings',
  async (data: ISlim360O365AiTimeSavings) => {
    const response = await o365AiTimeSavingsService
      .saveSlim360O365AiTimeSavings(data)
      .then((res) => {
        return res.body;
      });
    return response;
  }
);

export const deleteSlim360O365AiTimeSavings = createAsyncThunk(
  'deleteSlim360O365AiTimeSavings',
  async (id: number) => {
    const response = await o365AiTimeSavingsService
      .deleteSlim360O365AiTimeSavings(id)
      .then((res) => {
        return res.body;
      });
    return response;
  }
);
